module.exports = __webpack_public_path__ + "pc/img/swiper_bg_09.46ea89d2.jpg";